import styled, {css} from 'styled-components'

export const StyledPlanOfSubscription = styled.div<{
    isSelected: boolean
    disabled: boolean
    isActive: boolean
    extraContent: string
    extraDiscountContent: string
    hasCoupon: boolean
    isInnerElement: boolean
}>`
    ${({
        isSelected,
        disabled,
        isActive,
        hasCoupon,
        isInnerElement,
        onClick,
        extraDiscountContent,
        theme: {palette, spacing, typography}
    }) => css`
        display: flex;
        padding: ${spacing * 2}px ${spacing}px;
        flex-direction: column;
        gap: ${spacing}px;
        position: relative;
        border-bottom: 0.5px solid rgba(0, 6, 61, 0.45);
        width: 100%;
        border-radius: 4px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        ${isInnerElement &&
        css`
            border: 2px solid #fc9f21 !important;
            background: #fbfbe1;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        `}
        ${hasCoupon &&
        !isInnerElement &&
        css`
            background: #e2e2e2;
            cursor: default !important;
        `}
        ${(hasCoupon || isInnerElement) &&
        css`
            border: 1px solid #ccc;

            &::after {
                content: '${extraDiscountContent}';
                ${isInnerElement
                    ? css`
                          left: 8px;
                          top: 0;
                          transform: translateY(-50%);
                      `
                    : css`
                          left: 50%;
                          top: 50%;
                          transform: translateX(-50%) translateY(-50%);
                      `}

                position: absolute;

                display: flex;
                padding: 4px 8px;
                justify-content: center;
                align-items: center;
                gap: 10px;

                border-radius: 6px;
                background: #fc9f21;

                color: #fff;
                font-family: Inter;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                text-transform: capitalize;
                text-wrap: nowrap;
            }
        `}
        ${isActive &&
        css`
            &::before {
                ${typography.textXxs}
                position: absolute;
                content: ${({extraContent}: {extraContent: string}) => `'${extraContent || ''}'`};
                top: -10px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 2;
                display: flex;
                padding: ${spacing / 2}px ${spacing}px;
                justify-content: center;
                align-items: center;
                gap: ${spacing * 1.25}px;
                border-radius: 4px;
                background: linear-gradient(180deg, #864bd2 0%, #a069e8 100%);
                color: ${palette.neutral.white};
                font-family: Inter;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                white-space: nowrap;
            }
        `}
        ${onClick &&
        css`
            cursor: pointer;
        `}

        ${(!disabled || isActive) &&
        css`
            &:hover {
                border-radius: 4px;
                background: rgba(134, 75, 210, 0.2);
                transition: all 0.5s;
                border-color: transparent;
            }
        `}

        ${((!disabled && isSelected) || isActive) &&
        css`
            border-radius: 4px;
            border-color: ${palette.primary[900]};
            border-bottom: 0.5px solid;
            border-left: 0.5px solid;
            border-right: 0.5px solid;
            background: rgba(134, 75, 210, 0.2);
            transition: all 0.5s;
            border-top: 0.5px solid;
        `}
    `}
`
export const StyledPlanOfSubscriptionContent = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        /* width: 342px; */
        /* height: 79px; */
        /* align-items: center; */
        gap: ${spacing * 2}px;
        & span {
            display: flex;
            align-items: center;
            gap: ${spacing / 2}px;
        }
        & div {
            display: flex;
            gap: ${spacing}px;
            align-items: center;
        }
        & .title {
            color: #000;
            font-family: Inter;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        & .amount {
            color: #000;
            font-family: Inter;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            letter-spacing: -1px;
        }
        & .price {
            color: #000;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        & .line {
            position: relative;
            opacity: 0.5;
            font-weight: 400;
            &::after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                top: 50%;
                height: 1.5px;
                background: #7d7d70;
                transform: translateY(-50%);
            }
        }
        & .column {
            display: flex;
            flex-direction: column;
        }
    `}
`
export const StyledPlanOfSubscriptionPartOfContent = styled.div`
    ${({theme: {spacing, palette, typography}}) => css`
        display: flex;
        justify-content: space-between;
        flex: 1;
        gap: ${spacing}px;
        text-wrap: pretty;
        & div {
            display: flex;
            /* align-items: center; */
            gap: ${spacing}px;
            & h1 {
                ${typography.text2Xl}
                color: ${palette.neutral.black};
                font-weight: 700;
                letter-spacing: -1.3px;
            }
            & h2 {
                ${typography.textSm}
                color: ${palette.primary[900]};
                text-align: center;
                line-height: 140%;
                font-weight: 700;
            }
            & p {
                color: ${palette.primary[900]};
                overflow-wrap: anywhere;
                line-height: 140%; /* 19.6px */
            }
        }
    `}
`
export const StyledDescriptionOfPlan = styled.span`
    ${({theme: {typography, palette}}) => css`
        ${typography.textSm}
        color: ${palette.primary[900]};
        text-align: center;
        line-height: 140%;
        opacity: 0.5;
    `}
`
export const StyledMicromorgiContainer = styled.div`
    justify-content: center;
`
export const StyledTooltipBox = styled.div`
    display: flex;
    justify-content: start;
    align-items: start;
    height: 100%;
    & svg {
        width: 15px;
        height: 15px;
    }
`
